import React from 'react';
import { Link } from 'react-router-dom';

const HeaderNavbar = () => {
	return (
		<nav className="header__nav">
			<ul className="header__nav-list list-reset">
				<li className="header__nav-item">
					<Link  className="header__link" to="/">
						Dashboard
					</Link>
				</li>
				<li className="header__nav-item">
					<Link  className="header__link" to="/account">
						Account
					</Link>
				</li>
				<li className="header__nav-item">
					<Link  className="header__link" to="/help">
						Need help?
					</Link>
				</li>
				<li className="header__nav-item">
					<Link  className="header__link" to="/terms-conditions">
						{`Terms & Conditions`}
					</Link>
				</li>
				<li className="header__nav-item">
					<Link  className="header__link" to="/privacy">
						Privacy
					</Link>
				</li>
			</ul>
		</nav>
	);
};

export default HeaderNavbar;
